import { useContext } from 'react';
import { Button } from '@zopauk/web-ui';
import { env } from '@zopauk/nextjs-env';
import { logEvent } from '@/utils/analytics';
import { getSearchParam } from '@/utils/helpers';
import Events from '@/utils/amplitudeEvents.json';
import { CalculatorContext } from '@/components/Calculator/Context';
import { type UTMSearchParams, getUtmSearchParams, type UTMParams } from '@/components/Calculator/getUtmSearchParams';

interface ActionParams extends UTMSearchParams {
  origination_journey: string;
  clickId?: string;
  channel: string;
  amount: string;
  term: number;
}

interface CalculatorSubmissionProps {
  channel: string;
  action: string;
  amount: string;
  term: number;
}

interface FormProps {
  button?: string | null;
}

/**
 * Calculator Submission Handler
 */
const submitCalculator = ({ action, ...props }: CalculatorSubmissionProps) => {
  const clickId = getSearchParam('clickId');

  const params: ActionParams = {
    ...props,
    origination_journey: 'shopfront',
  };

  if (clickId) {
    params.clickId = clickId;
  }

  const utmParams = getUtmSearchParams();

  if (utmParams) {
    Object.keys(utmParams).map((item: string) => (params[item as UTMParams] = utmParams[item as UTMParams]));
  }

  const stringParams = Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join('&');

  const url = `${action}?${stringParams}`;

  logEvent(Events.SUBMIT_CALCULATOR, {
    referrer: window.location.href,
    target: '_self',
    href: url,
    ...params,
  });

  window.location.assign(url);
};

export const Form = ({ button }: FormProps) => {
  const context = useContext(CalculatorContext);

  if (!context.pricing) {
    return null;
  }

  const action =
    context.channel === 'upl'
      ? env('NEXT_PUBLIC_BORROW_SIGNUP_URL') || 'https://originations-web-public.staging.zopa.com/loans/quotation'
      : env('NEXT_PUBLIC_AUTO_SIGNUP_URL') || 'https://carfinancerates.zopa.com';

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        submitCalculator({
          term: context.selectedTerm,
          channel: context.channel,
          amount: context.amount,
          action,
        });
      }}
      method="GET"
    >
      <div className="lg:text-right text-left">
        <Button data-automation="ZA.button-personal-rate" className="w-full lg:w-auto" type="submit">
          {button || 'Get my personalised rates'}
        </Button>
      </div>
    </form>
  );
};
